import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, BehaviorSubject } from "rxjs";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { ApplicationNotesService } from "../../services/application-notes.service";
import { ApplicationsService } from "../../services/applications.service";
import { ApplicationFlowHistory, ApplicationEventType }from "../../models/applications.models";

@Component({
    selector: 'app-application-timeline',
    templateUrl: './application-timeline.component.html',
    styleUrls: ['./application-timeline.component.scss', '../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class ApplicationTimelineComponent extends SidePanelBase implements OnInit, OnDestroy {
    static componentName = 'ApplicationTimelineComponent';

    subscription: Subscription = new Subscription();

    eventTypes: ApplicationEventType[] = [];

     _timeline: ApplicationFlowHistory[] = [];

    get timeline(): ApplicationFlowHistory[] {
        return this._timeline;
    }

    constructor(private notesService: ApplicationNotesService, private sidePanelService: SidePanelService, private applicationsService: ApplicationsService) { super(); }

    ngOnInit() {

        let subs$: Subscription = this.notesService.timeline.pipe()
            .subscribe(
                (events: ApplicationFlowHistory[]) => {
                    this._timeline = events;
                },
                (error) => {
                    console.error(error);
                }
        );
        this.subscription.add(subs$);
        let event$: Subscription = this.applicationsService.getApplicationEventTypes().pipe()
            .subscribe(
                (data: ApplicationEventType[]) => {
                    this.eventTypes = data;
                },
                (error) => {
                    console.error(error);
                }
        );
        this.subscription.add(event$);
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    translateEventType(id: number): string {
        let match = this.eventTypes.find(e => e.id == id);
        if (match != null) return match.name;
        return id.toString();
    }
}
